const GUEST_FOLDERS_OFFICE_UID = "GUEST_FOLDERS";

/**
 * Returns a UID safe to send as `active_office_uid` on notary GETs (real office row only).
 * Omits empty strings and `GUEST_FOLDERS` so invited-notary navigation does not hit Prisma with a pseudo-office.
 */
export function resolveActiveOfficeUidForNotaryGetQuery(officeUid: string | null | undefined): string | undefined {
	if (officeUid == null) {
		return undefined;
	}
	const t = officeUid.trim();
	if (t.length === 0 || t === GUEST_FOLDERS_OFFICE_UID) {
		return undefined;
	}
	return t;
}

export function appendActiveOfficeUidSearchParam(url: URL, officeUid: string | null | undefined): void {
	const resolved = resolveActiveOfficeUidForNotaryGetQuery(officeUid);
	if (resolved !== undefined) {
		url.searchParams.set("active_office_uid", resolved);
	}
}
